"use client";

import { useEffect } from "react";
import { useParams } from "next/navigation";
import { PayloadPreview } from "@/components/form/payload-preview";
import { useStepPayloadPreviewContext } from "@/components/form/step-payload-preview-context";
import { StepLoader } from "@/components/loading";
import { useSubmitTask } from "@/hooks";
import { TaskType } from "@/types";
import { CreditCardInsuranceSaleContext, InsuranceSalePayload } from "../types";

interface Props {
	context: CreditCardInsuranceSaleContext;
	taskId: string;
}

const AUTO_SUBMIT_PAYLOAD: InsuranceSalePayload = {
	Insurance: false,
	ThirdpartyInsuranceConsent: false,
	CorrectInfoConfirmation: false,
	ThirdpartyInsuranceConsentText: "",
	CorrectInfoConfirmationText: "",
};

const CreditInsuranceSalePage = ({ taskId, context }: Props) => {
	const { flowId } = useParams<{ flowId: string }>();
	const flowPayload = useStepPayloadPreviewContext();

	const submit = useSubmitTask<InsuranceSalePayload>({
		taskId,
		processType: context.process,
		taskType: TaskType.InsuranceSale,
	});

	useEffect(() => {
		const onSubmit = async () => {
			await submit(AUTO_SUBMIT_PAYLOAD);
		};
		onSubmit();
	}, [context.process, flowId, submit, taskId]);

	return (
		<>
			<StepLoader />
			<PayloadPreview flowPayload={flowPayload} payload={AUTO_SUBMIT_PAYLOAD} />
		</>
	);
};

export default CreditInsuranceSalePage;
